<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="语言" required class="locale-select-item">
        <a-select
          mode="multiple"
          v-model="selectedLocales"
          placeholder="请选择语言"
          class="locale-select"
          :maxTagCount="4"
          :allowClear="false"
          @change="handleLocaleChange"
        >
          <a-select-option v-for="item in localeFields" :key="item.key" :value="item.key">
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <div v-for="item in visibleLocaleFields" :key="item.key" class="locale-block">
        <a-form-model-item
          :label="item.label + '剧名'"
          :prop="item.videoName"
          class="locale-name-item"
        >
          <a-input
            class="locale-name-input"
            show-count
            v-model="form[item.videoName]"
            :placeholder="'请输入' + item.label + '剧名'"
          />
        </a-form-model-item>

        <a-form-model-item
          :label="item.label + '封面图'"
          :prop="item.coverUrl"
        >
          <a-upload
            listType="picture-card"
            class="avatar-uploader"
            v-model="form[item.coverUrl]"
            :showUploadList="false"
            :beforeUpload="file => beforeCoverUpload(item.coverUrl, file)"
            :customRequest="info => handleCoverUpload(item.coverUrl, info)"
          >
            <plus-outlined />
            <div v-if="form[item.coverUrl]" class="upload-image-wrapper">
              <img :src="form[item.coverUrl]" alt="cover" style="height:104px;max-width:300px"/>
              <div v-if="coverUploadLoading[item.coverUrl]" class="upload-mask">
                <a-icon type="loading" style="font-size: 24px; color: #1890ff;"/>
              </div>
            </div>
            <div v-else>
              <a-icon :type="coverUploadLoading[item.coverUrl] ? 'loading' : 'plus'"/>
              <div class="ant-upload-text">上传</div>
            </div>
          </a-upload>
        </a-form-model-item>

        <a-form-model-item
          :label="item.label + '简介'"
          :prop="item.introductions"
        >
          <a-textarea show-count :maxLength="500" v-model="form[item.introductions]" :placeholder="'请输入' + item.label + '简介'" />
        </a-form-model-item>
      </div>

      <a-form-model-item label="总集数" prop="totalNum" >
        <a-input-number :min="0" v-model="form.totalNum" placeholder="请输入总集数" @change="validateFreeLimitNumOnTotalChange" />
      </a-form-model-item>
      <a-form-model-item label="标签" prop="type" >
        <a-select placeholder="请选择标签" v-model="form.type" allow-clear>
          <a-select-option :key="0">无标签</a-select-option>
          <a-select-option :key="1">NEW</a-select-option>
          <a-select-option :key="2">Hot</a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="是否上映" prop="isRelease" >
        <a-select placeholder="请选择是否上映" @change="updateIsGo" v-model="form.isRelease">
          <a-select-option :key="0">否</a-select-option>
          <a-select-option :key="1">是</a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item v-if="this.isGo=='0'" label="上映时间" prop="releaseTime" >
        <a-date-picker
          :allow-clear="true"
          size="default"
          v-model="form.releaseTime"
          placeholder="上映时间"
          value-format="YYYY-MM-DD HH:mm:ss"
          format="YYYY-MM-DD HH:mm:ss"
          show-time
          @change="handleReleaseTimeChange">
        </a-date-picker>
      </a-form-model-item>

      <a-form-model-item label="分类" prop="tagIds" >
        <!--        <a-input v-model="form.tagIds" placeholder="请输入标签ids" />-->
        <a-tree-select
          v-model="tagIds"
          style="width: 100%"
          :tree-data="treeData"
          tree-checkable
          search-placeholder="请选择分类"
          @change="changeSelect"
        />
      </a-form-model-item>
      <!--      <a-form-model-item label="前多少集可以使用金币观看" prop="limitNum" >-->
      <!--        <a-input-number :min="0" v-model="form.limitNum" placeholder="请输入" />-->
      <!--      </a-form-model-item>-->
      <a-form-model-item label="前多少集可以免费观看" prop="freeLimitNum" >
        <a-input-number :min="0" :precision="0" v-model="form.freeLimitNum" placeholder="请输入" @change="handleFreeLimitNumChange" />
      </a-form-model-item>

      <a-form-model-item label="试看时长" prop="freeSecond" >
        <a-input-number :min="0" :precision="0" v-model="form.freeSecond" placeholder="请输入" @change="handleFreeLimitNumChange" />
      </a-form-model-item>
      <a-form-model-item label="每集金币价格" prop="diamondPrice" >
        <a-input-number :min="0" :precision="0" v-model="form.diamondPrice" placeholder="请输入" @change="handleDiamondPriceChange" />
      </a-form-model-item>
      <a-form-model-item label="每集金币价格(优惠价格)" prop="discountPrice" >
        <a-input-number :min="0" v-model="form.discountPrice" placeholder="请输入" @change="handleDiscountPriceChange" />
      </a-form-model-item>
      <!--      <a-form-model-item label="每集金币价格" prop="goldPrice" >-->
      <!--        <a-input-number :min="0" v-model="form.goldPrice" placeholder="请输入" />-->
      <!--      </a-form-model-item>-->
      <!--      <a-form-model-item label="备注" prop="remark" >-->
      <!--        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />-->
      <!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getVideo, addVideo, updateVideo } from '@/api/video/video'
import { listTag } from '@/api/video/tag'
import UploadFileToVOD from '@/api/vod.js'

const LOCALE_FIELDS = [
  { key: 'zh', label: '中文简体', videoName: 'videoName', coverUrl: 'coverUrl', introductions: 'introductions' },
  { key: 'tc', label: '中文繁体', videoName: 'videoNameTc', coverUrl: 'coverUrlTc', introductions: 'introductionsTc' },
  { key: 'en', label: '英文', videoName: 'videoNameEn', coverUrl: 'coverUrlEn', introductions: 'introductionsEn' },
  { key: 'jp', label: '日语', videoName: 'videoNameJp', coverUrl: 'coverUrlJp', introductions: 'introductionsJp' },
  { key: 'ko', label: '韩语', videoName: 'videoNameKo', coverUrl: 'coverUrlKo', introductions: 'introductionsKo' },
  { key: 'fr', label: '法语', videoName: 'videoNameFr', coverUrl: 'coverUrlFr', introductions: 'introductionsFr' },
  { key: 'ab', label: '阿拉伯语', videoName: 'videoNameAb', coverUrl: 'coverUrlAb', introductions: 'introductionsAb' },
  { key: 'vi', label: '越南语', videoName: 'videoNameVi', coverUrl: 'coverUrlVi', introductions: 'introductionsVi' }
]

const DEFAULT_SELECTED_LOCALES = ['zh']

function buildLocaleFormFields () {
  const fields = {}
  LOCALE_FIELDS.forEach(item => {
    fields[item.videoName] = null
    fields[item.coverUrl] = null
    fields[item.introductions] = null
  })
  return fields
}

function buildCoverUploadLoading () {
  const loading = {}
  LOCALE_FIELDS.forEach(item => {
    loading[item.coverUrl] = false
  })
  return loading
}

function hasLocaleContent (form, item) {
  const name = form[item.videoName]
  const cover = form[item.coverUrl]
  const intro = form[item.introductions]
  return !!(name || cover || intro)
}

function buildLocaleRules () {
  const rules = {}
  LOCALE_FIELDS.forEach(item => {
    rules[item.videoName] = []
    rules[item.coverUrl] = []
    rules[item.introductions] = [{ max: 500, message: '简介最多500字' }]
  })
  return rules
}

function getBaseFormFields () {
  return {
    id: null,
    lookNum: null,
    limitNum: null,
    diamondPrice: null,
    discountPrice: null,
    goldPrice: null,
    tagIds: null,
    totalNum: null,
    type: 0,
    createTime: null,
    remark: null,
    isRelease: 1,
    releaseTime: null,
    freeLimitNum: null,
    freeSecond: null,
    sort: null,
    trendingSort: null,
    isComplete: null,
    ...buildLocaleFormFields()
  }
}

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      isGo: false,
      tagIds: [],
      localeFields: LOCALE_FIELDS,
      selectedLocales: [...DEFAULT_SELECTED_LOCALES],
      coverUploadLoading: buildCoverUploadLoading(),
      // 表单参数
      form: getBaseFormFields(),
      // 1增加,2修改
      formType: 1,
      open: false,
      treeData: [],
      rules: {
        lookNum: [
          { required: true, message: '观看数不能为空' }
        ],
        limitNum: [
          { required: true, message: '前多少集可以使用金币观看不能为空' }
        ],
        freeLimitNum: [
          { required: true, message: '前多少集可以免费观看不能为空' },
          { validator: this.validateFreeLimitNum, trigger: ['blur', 'change'] }
        ],
        tagIds: [
          { required: false, message: '标签不能为空' }
        ],
        totalNum: [
          { required: true, message: '总集数不能为空' }
        ],
        releaseTime: [
          { required: false, message: '请选择上映时间' },
          { validator: this.validateReleaseTime, trigger: ['blur', 'change'] }
        ],
        ...buildLocaleRules(),
        diamondPrice: [
          { validator: this.validateDiamondPrice, trigger: ['blur', 'change'] }
        ],
        discountPrice: [
          { validator: this.validateDiscountPrice, trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  filters: {
  },
  created () {

  },
  computed: {
    visibleLocaleFields () {
      return this.localeFields.filter(item => this.selectedLocales.includes(item.key))
    }
  },
  watch: {
  },
  mounted () {
    // this.getAllList()
  },
  methods: {
    handleLocaleChange (value) {
      if (!value || value.length === 0) {
        this.selectedLocales = [...DEFAULT_SELECTED_LOCALES]
        this.$message.warning('请至少选择一种语言')
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },
    resolveSelectedLocalesFromData (data) {
      const keys = LOCALE_FIELDS
        .filter(item => hasLocaleContent(data || {}, item))
        .map(item => item.key)
      return keys.length ? keys : [...DEFAULT_SELECTED_LOCALES]
    },
    validateLocaleContent () {
      if (!this.selectedLocales || this.selectedLocales.length === 0) {
        this.$message.error('请至少选择一种语言')
        return false
      }
      const hasOneLocaleFilled = this.visibleLocaleFields.some(item => hasLocaleContent(this.form, item))
      if (!hasOneLocaleFilled) {
        this.$message.error('至少选择一种语言填写剧名、封面或简介，不能全部为空')
        return false
      }
      return true
    },
    loadFormFromApi (data) {
      const form = { ...getBaseFormFields(), ...(data || {}) }
      LOCALE_FIELDS.forEach(item => {
        form[item.videoName] = data && data[item.videoName] != null ? data[item.videoName] : ''
        form[item.coverUrl] = data && data[item.coverUrl] != null ? data[item.coverUrl] : ''
        form[item.introductions] = data && data[item.introductions] != null ? data[item.introductions] : ''
      })
      this.form = form
      this.selectedLocales = this.resolveSelectedLocalesFromData(form)
    },
    buildSubmitPayload () {
      const payload = {
        id: this.form.id,
        lookNum: this.form.lookNum,
        isRelease: this.form.isRelease,
        freeSecond: this.form.freeSecond,
        trendingSort: this.form.trendingSort,
        releaseTime: this.form.releaseTime,
        limitNum: this.form.limitNum,
        type: this.form.type,
        freeLimitNum: this.form.freeLimitNum,
        diamondPrice: this.form.diamondPrice,
        discountPrice: this.form.discountPrice,
        goldPrice: this.form.goldPrice,
        tagIds: this.tagIds && this.tagIds.length ? this.tagIds.join(',') : this.form.tagIds,
        totalNum: this.form.totalNum,
        remark: this.form.remark,
        sort: this.form.sort,
        isComplete: this.form.isComplete
      }
      LOCALE_FIELDS.forEach(item => {
        payload[item.videoName] = this.form[item.videoName]
        payload[item.coverUrl] = this.form[item.coverUrl]
        payload[item.introductions] = this.form[item.introductions]
      })
      return payload
    },
    validateFreeLimitNum (rule, value, callback) {
      if (value === null || value === undefined || value === '') {
        callback()
        return
      }
      if (this.form.totalNum !== null && this.form.totalNum !== undefined && value > this.form.totalNum) {
        callback(new Error('前多少集可以免费观看不能大于总集数'))
      } else {
        callback()
      }
    },
    validateFreeLimitNumOnTotalChange () {
      // 当总集数变化时，重新验证免费观看集数
      if (this.$refs.form && this.form.freeLimitNum !== null && this.form.freeLimitNum !== undefined) {
        this.$refs.form.validateField('freeLimitNum')
      }
    },
    handleFreeLimitNumChange () {
      // 当免费观看集数变化时，触发验证
      if (this.$refs.form) {
        this.$refs.form.validateField('freeLimitNum')
      }
    },
    validateDiamondPrice (rule, value, callback) {
      if (value === null || value === undefined || value === '') {
        callback()
        return
      }
      // 原价不能小于优惠价格
      if (this.form.discountPrice !== null && this.form.discountPrice !== undefined && value < this.form.discountPrice) {
        callback(new Error('每集金币价格不能小于每集金币价格(优惠价格)'))
      } else {
        callback()
      }
    },
    validateDiscountPrice (rule, value, callback) {
      if (value === null || value === undefined || value === '') {
        callback()
        return
      }
      // 优惠价格不能大于原价
      if (this.form.diamondPrice !== null && this.form.diamondPrice !== undefined && value > this.form.diamondPrice) {
        callback(new Error('每集金币价格(优惠价格)不能大于每集金币价格'))
      } else {
        callback()
      }
    },
    handleDiamondPriceChange () {
      // 当每集金币价格变化时，重新验证优惠价格
      if (this.$refs.form && this.form.discountPrice !== null && this.form.discountPrice !== undefined) {
        this.$refs.form.validateField('discountPrice')
      }
      // 同时验证自己
      if (this.$refs.form) {
        this.$refs.form.validateField('diamondPrice')
      }
    },
    handleDiscountPriceChange () {
      // 当优惠价格变化时，重新验证每集金币价格
      if (this.$refs.form && this.form.diamondPrice !== null && this.form.diamondPrice !== undefined) {
        this.$refs.form.validateField('diamondPrice')
      }
      // 同时验证自己
      if (this.$refs.form) {
        this.$refs.form.validateField('discountPrice')
      }
    },
    updateIsGo(value) {
      this.isGo = value
      // 当"是否上映"变化时，重新验证上映时间
      this.$nextTick(() => {
        if (this.$refs.form && this.form.releaseTime) {
          this.$refs.form.validateField('releaseTime')
        }
      })
    },
    validateReleaseTime (rule, value, callback) {
      if (value === null || value === undefined || value === '') {
        callback()
        return
      }
      // 当"是否上映"为"否"（isRelease = 0）时，上映时间不能早于当前时间
      if (this.form.isRelease === 0 || this.form.isRelease === '0') {
        const now = new Date()
        // 将 YYYY-MM-DD HH:mm:ss 格式的字符串转换为日期对象
        const releaseDate = new Date(value.replace(/-/g, '/'))
        // 比较完整时间（包括年月日时分秒）
        if (releaseDate < now) {
          callback(new Error('上映时间不能早于当前时间'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    },
    handleReleaseTimeChange () {
      // 当上映时间变化时，触发验证
      if (this.$refs.form) {
        this.$refs.form.validateField('releaseTime')
      }
    },
    handleCoverUpload (coverField, info) {
      const that = this
      that.$set(that.coverUploadLoading, coverField, true)
      // 封面继续走腾讯点播，保持 *.vod-qcloud.com 地址；不替换 CDN、不挂 HLS 任务流
      new UploadFileToVOD([info.file], {
        forImage: true,
        skipCdnRewrite: true,
        success (fileName) {
          that.$set(that.form, coverField, fileName[0])
          that.$set(that.coverUploadLoading, coverField, false)
          that.$nextTick(() => {
            if (that.$refs.form) {
              that.$refs.form.clearValidate(coverField)
            }
          })
        },
        error () {
          that.$set(that.coverUploadLoading, coverField, false)
          that.$message.error('上传失败，请重试')
        }
      })
    },
    beforeCoverUpload (coverField, file) {
      if (file.type.indexOf('image') < 0) {
        this.$message.warning('请上传图片')
        this.$set(this.coverUploadLoading, coverField, false)
        return false
      }
      this.$set(this.form, coverField, '')
      this.$set(this.coverUploadLoading, coverField, true)
    },
    handleUpload(info) { // 兼容旧入口：封面走 VOD，保持 vod-qcloud.com
      this.handleCoverUpload('coverUrl', info)
    },
    changeSelect(e, label, extra) {
      // 过滤掉新选择的 isOpen=0 的节点（但保留已存在的）
      const currentTagIds = this.tagIds || []
      const filteredIds = e.filter(id => {
        const node = this.treeData.find(item => item.value === id)
        // 如果节点不存在，允许保留
        if (!node) return true
        // 如果是 isOpen=0 的节点，检查是否已经在原来的 tagIds 中
        if (node.isOpen === 0) {
          return currentTagIds.includes(id)
        }
        return true
      })
      this.tagIds = filteredIds
      this.form.tagIds = filteredIds.join(',')
      // 更新 treeData 的禁用状态
      this.updateTreeDataDisabled()
    },
    resolveChineseTagTitle (tag) {
      const hasHan = (text) => text && /[\u4e00-\u9fff]/.test(text)
      if (hasHan(tag.tagTitle)) {
        return tag.tagTitle.trim()
      }
      if (hasHan(tag.tagTitleTc)) {
        return tag.tagTitleTc.trim()
      }
      return (tag.tagTitle || '').trim()
    },
    getAllList() {
      listTag().then(res => {
        this.treeData = (res.data || [])
          .map(i => ({
            title: this.resolveChineseTagTitle(i),
            isOpen: i.isOpen,
            value: i.id,
            key: i.id,
            sort: i.sort == null ? 0 : i.sort,
            disabled: i.isOpen === 0
          }))
          .sort((a, b) => a.sort - b.sort)
        // 如果已有 tagIds，更新禁用状态
        if (this.tagIds && this.tagIds.length > 0) {
          this.updateTreeDataDisabled()
        }
      })
    },
    updateTreeDataDisabled() {
      // 更新 treeData 的 disabled 状态
      this.treeData = this.treeData.map(item => ({
        ...item,
        disabled: item.isOpen === 0 && (!this.tagIds || !this.tagIds.includes(item.value))
      }))
    },
    onClose () {
      this.tagIds = null
      this.open = false
      this.selectedLocales = [...DEFAULT_SELECTED_LOCALES]
      // 清除表单验证状态
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
      // 清除表单验证状态
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.selectedLocales = [...DEFAULT_SELECTED_LOCALES]
      this.coverUploadLoading = buildCoverUploadLoading()
      this.form = getBaseFormFields()
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.getAllList()
      this.open = true
      this.updateIsGo(0)
      this.isGo = 1
      // 清除表单验证状态
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.getAllList()
      this.formType = 2
      const id = row ? row.id : ids
      getVideo({ 'id': id }).then(response => {
        this.loadFormFromApi(response.data)
        this.isGo = response.data.isRelease
        if (response.data.tagIds) {
          this.tagIds = response.data.tagIds.split(',')
        } else {
          this.tagIds = null
        }
        // 更新 treeData 的禁用状态，允许已存在的 isOpen=0 节点可以取消选择
        this.updateTreeDataDisabled()
        this.open = true
        this.formTitle = '修改'
        // 清除表单验证状态
        this.$nextTick(() => {
          if (this.$refs.form) {
            this.$refs.form.clearValidate()
          }
        })
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return false
        }
        if (!this.validateLocaleContent()) {
          return false
        }
        this.submitLoading = true
        const payload = this.buildSubmitPayload()
        if (this.form.id !== undefined && this.form.id !== null) {
          updateVideo(payload).then(response => {
            this.$message.success(
              '修改成功',
              3
            )
            this.open = false
            this.tagIds = null
            this.$emit('ok')
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          addVideo(payload).then(response => {
            this.$message.success(
              '新增成功',
              3
            )
            this.open = false
            this.tagIds = null
            this.$emit('ok')
          }).finally(() => {
            this.submitLoading = false
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.locale-select-item {
  :deep(.ant-form-item-control) {
    line-height: 1.5;
  }
}

.locale-select {
  width: 520px;
  max-width: 100%;

  :deep(.ant-select-selection) {
    min-height: 40px;
    padding: 4px 8px;
    border-radius: 6px;
  }

  :deep(.ant-select-selection--multiple .ant-select-selection__choice) {
    height: 28px;
    line-height: 26px;
    margin: 2px 4px 2px 0;
    padding: 0 8px;
    border-radius: 4px;
    background: #f0f5ff;
    border-color: #d6e4ff;
    color: #2f54eb;
  }

  :deep(.ant-select-selection--multiple .ant-select-selection__rendered) {
    margin-left: 4px;
    line-height: 30px;
  }
}

.locale-block {
  padding: 12px 16px 4px;
  margin-bottom: 12px;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  background: #fafafa;
}

.locale-name-item {
  :deep(.ant-form-item-control) {
    line-height: 40px;
  }
}

.locale-name-input {
  width: 420px;
  max-width: 100%;
}

.upload-image-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    max-width: 100%;
    max-height: 100%;
  }
}

.upload-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: 4px;
}

.avatar-uploader {
  :deep(.ant-upload-select-picture-card) {
    width: 104px;
    height: 104px;
  }

  :deep(.ant-upload-select-picture-card:hover) {
    border-color: #1890ff;
  }
}
</style>
